import {jwtServerInstance} from "../index";
import qs from	'qs'

export const getAllShopMajorType = () =>{
    return jwtServerInstance.request({
        url:'/shopmajortype/all',
        method:'post'
    });
}
